<!-- <app-navbar-style-two></app-navbar-style-two>
<div class="container">
    <div class="blog-area">
      <div class="container">
        <div class="blog-header text-center">
          <h2>Latest Blog Posts</h2>
        </div>
      </div>
    </div>
    <div class="row pt-45">
      <div align="center" *ngIf="gifLoader">
        <img height="100px" width="100px"
            src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif"
            loading="lazy">
       </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-12" *ngFor="let blog of blog$">
        <div class="blog-card">
          <div class="card-header">
            <a (click)="openBlogDetail(blog)">
              <img [src]="getImageUrl(blog)" alt="{{ blog.title }}" />
            </a>
          </div>
          <div class="card-body">
            <h3 class="card-title">
              <a (click)="openBlogDetail(blog)">{{ blog.title }}</a>
            </h3>
            <p class="card-text">
              {{ blog.description | slice: 0:100 }}...
            </p>
            <a (click)="openBlogDetail(blog)" class="read-more">Read More</a>
          </div>
        </div>
      </div>
    </div>
    <nav *ngIf="totalPages > 1">
      <ul class="pagination justify-content-center mt-4">
        <li class="page-item">
          <a class="page-link" (click)="changePage(currentPage - 1)">❮ Prev</a>
        </li>

        <li class="page-item" *ngFor="let page of getPages()"
            [class.active]="page === currentPage">
          <a class="page-link" (click)="changePage(page)">{{ page }}</a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages-1">
          <a class="page-link" (click)="changePage(currentPage + 1)">Next ❯</a>
        </li>
      </ul>
    </nav>
  </div>


  <app-footer-style-two></app-footer-style-two> -->

  <app-navbar-style-two></app-navbar-style-two>
<div class="container">
    <div class="blog-area">
      <div class="container">
        <div class="blog-header text-center">
          <h2>Latest Blog Posts</h2>
        </div>
      </div>
    </div>
    <div class="row pt-45">
      <div align="center" *ngIf="gifLoader">
        <img height="100px" width="100px"
            src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif"
            loading="lazy">
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-12" *ngFor="let blog of paginatedBlogs">
        <div class="blog-card">
          <div class="card-header">
            <a (click)="openBlogDetail(blog)">
              <img [src]="getImageUrl(blog)" alt="{{ blog.title }}" />
            </a>
          </div>
          <div class="card-body">
            <h3 class="card-title">
              <a (click)="openBlogDetail(blog)">{{ blog.title }}</a>
            </h3>
            <p class="card-text">
              {{ blog.description | slice: 0:100 }}...
            </p>
            <a (click)="openBlogDetail(blog)" class="read-more">Read More</a>
          </div>
        </div>
      </div>
    </div>
    <nav *ngIf="totalPages > 1">
      <ul class="pagination justify-content-center mt-4">
        <li class="page-item">
          <a class="page-link" (click)="changePage(currentPage - 1)" [class.disabled]="currentPage === 0">❮ Prev</a>
        </li>

        <li class="page-item" *ngFor="let page of getPages()"
            [class.active]="page === currentPage">
          <a class="page-link" (click)="changePage(page)">{{ page + 1 }}</a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages - 1">
          <a class="page-link" (click)="changePage(currentPage + 1)">Next ❯</a>
        </li>
      </ul>
    </nav>
</div>

<app-footer-style-two></app-footer-style-two>
